import React from "react"

import './BrowserCard.css'
import { Card, CardActions, CardContent, CardHeader, Grid, IconButton, Stack, styled, Typography } from "@mui/material"
import { CoveringTooltip } from "./CoveringTooltip"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export type CardColor = 'lightGold' | 'primary' | 'electricMint' | 'midnightBlue' | 'gray' | 'pastelRed'

interface ColoredCardProps {
  cardcolor: CardColor
}

const ColoredCard = styled(Card)<ColoredCardProps>(({ theme, cardcolor: cardColor }) => ({
  border: '1px solid',
  borderRadius: '25px',
  borderColor: cardColor === 'midnightBlue' ? 'rgb(37 133 221 / 40%)' : theme.palette[cardColor].main,
  backgroundColor: theme.palette[cardColor].light,
  boxShadow: '0px 2px 3px 1px #0000000d',
  transition: 'all 0.1s ease-in-out',
  padding: '16px',
  paddingBottom: '8px',
  '&:hover': {
    boxShadow: '3px 3px 15px #00000026'
  },
  '& .MuiCardHeader-root': {
    padding: '8px'
  },
  '& .MuiCardContent-root': {
    paddingTop: '8px'
  }
}))

interface BrowserCardProps {
  title: string
  titleTooltipText?: string
  button?: JSX.Element
  children: React.ReactNode
  cardColor: CardColor
  label: React.ReactNode
  onInfoClick?: () => void
}

const BrowserCard: React.FC<BrowserCardProps> = ({ title, titleTooltipText, button, children, cardColor, label, onInfoClick }) => {
  const justifyContent = onInfoClick ? 'space-between' : 'flex-end'
  return (
    <Grid item md={12} lg={6} xl={4}>
      <ColoredCard className={`card-frame`} cardcolor={cardColor}>
        <CardHeader disableTypography title={label} />
        <CardContent sx={{ padding: '8px' }}>
          <Stack spacing={0.5}>
            <CoveringTooltip title={titleTooltipText || ""} >
              <Typography variant="h6" sx={{ width: 'fit-content' }}>{trimTitle(title)}</Typography>
            </CoveringTooltip>
            {children}
          </Stack>
        </CardContent>
        <CardActions sx={{ justifyContent: justifyContent }}>
          {onInfoClick && <IconButton color={cardColor} sx={{ p: 0.5 }} onClick={onInfoClick}>
            <InfoOutlinedIcon />
          </IconButton>}
          {button}
        </CardActions>
      </ColoredCard>
    </Grid>
  )
}

export default BrowserCard

const MAX_LENGTH = 30

export function trimTitle(title: string): string {
  if (title.length > MAX_LENGTH) {
    if (title.endsWith("and 1 more file")) {
      return title.substring(0, 13) + "..." + title.slice(title.length - 15)
    }
    if (title.match(new RegExp("and \\d{1} more files"))) {
      return title.substring(0, 12) + "..." + title.slice(title.length - 16)
    }
    if (title.match(new RegExp("and \\d{2} more files"))) {
      return title.substring(0, 11) + "..." + title.slice(title.length - 17)
    }
    return title.substring(0, 20) + "..." + title.slice(title.length - 7)
  }
  return title
}